import { jsx as e } from "react/jsx-runtime";
import { createElement as a, useState as c, useEffect as _ } from "react";
import f from "classnames";
import "../Breadcrumbs/index.js";
import "../Button/index.js";
import "reactjs-popup";
import "../ThemeContext/index.js";
import "../Modal/index.js";
import "react-i18next";
import "../../fields/Input/index.js";
import "../Tooltip/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../index-YV3Z4nmr.js";
import "react-dropzone";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import u from "../../helpers/nanoid.js";
const l = "forma-ui__notifications__root", S = "forma-ui__notifications__item", R = "forma-ui__notifications__visible", E = "forma-ui__notifications__ERROR", C = "forma-ui__notifications__ERROR", d = "forma-ui__notifications__SUCCESS", v = "forma-ui__notifications__SUCCESS", t = {
  root: l,
  item: S,
  visible: R,
  ERROR: E,
  error: C,
  SUCCESS: d,
  success: v
}, N = ({ id: o = u(8), type: r = "ALERT", content: i, timeout: m = 5e3, onRemove: n }) => {
  const [p, s] = c(!1);
  return _(() => {
    setTimeout(() => s(!0), 100), setTimeout(() => s(!1), m - 300), setTimeout(() => n(o), m);
  }, []), i ? /* @__PURE__ */ e("div", { className: f(t.item, t[r], p && t.visible), children: i }) : null;
}, oo = ({ items: o, onRemove: r }) => /* @__PURE__ */ e("div", { className: t.root, children: o == null ? void 0 : o.map((i) => /* @__PURE__ */ a(N, { ...i, onRemove: r, key: i.id })) });
export {
  oo as default
};
